/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-12-28 18:20:41
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-08-21 11:34:33
 * @FilePath: \baishu_react_ui\src\auth.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 用户授权登录组件
import React, { useContext, useEffect, useState } from "react";
import BsySLoading from "./components/BsySLoading";
import _ from "lodash";
// 方便透传用户信息和更新用户信息方法
// 注意:  特别主要我们的弹层由于脱离了App的作用域，是获取不到的哦
const LocalDevInfoStateContext = React.createContext({
  data: null,
  refresh: () => { },
});
/**
 * react 函数式组件获取用户信息hook
 * @returns {{data: null, refresh: refresh}}
 */

export const LocalDevInfoStateProvider = LocalDevInfoStateContext.Provider;
export const useLocalDevInfoState = function () {
  return useContext(LocalDevInfoStateContext);
};

/**
 * react class组件获取用户信息hoc
 * @param Component
 * @returns {React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
export const withLocalDevInfoState = function (Component) {
  return React.forwardRef((props, ref) => {
    return (
      <LocalDevInfoStateContext.Consumer>
        {(localDevInfoState) => {
          return React.createElement(Component, {
            ...props,
            ref: ref,
            localDevInfoState,
          });
        }}
      </LocalDevInfoStateContext.Consumer>
    );
  });
};

let _userInfoPromise = undefined;
function Auth(props) {
  const { children } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState(window.localDevInfo);
  const getLocalDevInfo = function () {
    if (!_userInfoPromise) {
      _userInfoPromise = React.axios("/team/getLocalDevInfo");
    }
    return _userInfoPromise
      .then((res) => {
        res.data._t = Date.now();
        setData(res.data);
        window.localDevInfo = res.data;
        window.FX.STATIC.user = res.data.user;
        window.FX.STATIC.user_corps = res.data.user_corps;
        window.FX.STATIC.corpId = res.data.corpId;
        window.FX.STATIC.VIP_PACK = res.data.VIP_PACK
        if (window.FX.STATIC.user) {
          const id = window.FX.STATIC.user
            ? window.FX.STATIC.user.dock_userid
              ? window.FX.STATIC.user.dock_userid
              : window.FX.STATIC.user._id
            : "";
          if (id) {
            window.userSelectMap[id] = window.userSelectMap[id] || {
              ...window.FX.STATIC.user,
              id: id,
            };
            window.userSelectMap["100000000000000000000001"] =
              window.userSelectMap[id];
          }
        }

        window.deptSelectMap = window.deptSelectMap || {};
        var ids = res.data.user.current_departments;
        for (let index = 0; index < ids.length; index++) {
          const element = ids[index];
          let sid = element._id || element.id;
          window.deptSelectMap[sid] = element;
        }
        window.deptSelectMap["110000000000000000000001"] = _.cloneDeep(res.data.user.current_departments);

        ids = res.data.user.current_sub_departments;
        for (let index = 0; index < ids.length; index++) {
          const element = ids[index];
          let sid = element._id || element.id;
          window.deptSelectMap[sid] = element;
        }
        window.deptSelectMap["110000000000000000000002"] = _.cloneDeep(res.data.user.current_sub_departments);


      })
      .catch((error) => {
        setError(error);
      });
  };
  useEffect(() => {
    if (!window.localDevInfo) {
      setLoading(true);
      getLocalDevInfo().finally(() => {
        setLoading(false);
      });
    }
  }, []);
  if (loading || error) {
    return <BsySLoading style={{ background: "#f5f7fa" }} />;
  }
  if (data) {
    return (
      <LocalDevInfoStateProvider
        value={{
          data,
          refresh() {
            _userInfoPromise = undefined;
            return getLocalDevInfo();
          },
        }}
      >
        {children}
      </LocalDevInfoStateProvider>
    );
  }
  return null;
}

export default Auth;
